<template>
  <div class="loading-container">
    <ClipLoader
      :loading="isLoading"
      :color="color"
      :size="size"
    />
  </div>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
export default {
  name: 'AppLoadSpinner',
  components: { ClipLoader },
  props: {
    isLoading: Boolean,
    color: {
      type: String,
      default: 'white'
    },
    size: {
      type: String,
      default: '10px'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='scss' scoped>

.loading-container {
  margin: 0 0.5rem;
}

</style>
